import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function OpenMiniMapIconSvg() {
  return (
    <div className="flex flex-col items-center my-[5px]">
      <svg
        version="1.1"
        id="Capa_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 136.039 136.039"
        style={{ width: '25px', height: '25px' }}
        xmlSpace="preserve"
      >
        <g>
          <g>
            <path
              style={{ fill: '#ffffff' }}
              d="M107.022,74.78h-6.432c-1.712,2.846-3.52,5.585-5.394,8.139h6.749l21.057,43.117H13.026 l21.063-43.117h6.749c-1.874-2.572-3.682-5.311-5.4-8.139h-6.432L0,134.174h136.039L107.022,74.78z"
            />
            <path
              style={{ fill: '#ffffff' }}
              d="M68.016,1.865c-21.23,0-38.439,17.214-38.439,38.439c0,33.307,38.439,64.06,38.439,64.06 s38.439-30.753,38.439-64.06C106.449,19.079,89.246,1.865,68.016,1.865z M68.016,55.692c-8.479,0-15.377-6.886-15.377-15.383 c0-8.485,6.898-15.371,15.377-15.371c8.473,0,15.377,6.886,15.377,15.371C83.387,48.8,76.489,55.692,68.016,55.692z"
            />
          </g>
        </g>
      </svg>
      <p className="text-[#fff] text-[10px] font-bold m-0">Map</p>
    </div>
  )
}

export default function OpenMiniMapIcon(
  props: Partial<CustomIconComponentProps>
) {
  return <Icon component={() => OpenMiniMapIconSvg()} {...props} />
}
